<template>
  <vue-tailwind-modal v-if="showModal" :showing="true" @close="showModal = false" :showClose="true"
                      :backgroundClose="false">
    <NewGroup v-if="modalData.modal === 'groups'"/>
    <NewBroadcastMessageComponent :fullscreen="false" :breadcrumb="false" v-if="modalData.modal === 'broadcast'"/>
    <ScheduleBlastComponent :id="modalData.id" :breadcrumb="false" v-if="modalData.modal === 'schedule'"/>
    <SubscribeReport :report="modalData.report" :report-name="modalData.reportName" v-if="modalData.modal === 'subscribe'"/>
  </vue-tailwind-modal>
</template>

<script>

//import VueTailwindModal from 'vue-tailwind-modal'
import VueTailwindModal from "vue-tailwind-modal/src/VueTailwindModal.vue"

import NewGroup from "@/modules/customers/Groups/NewGroup";
import NewBroadcastMessageComponent from "@/modules/Broadcasts/NewBroadcastMessageComponent";
import ScheduleBlastComponent from "@/modules/Broadcasts/ScheduleBlastComponent";
import SubscribeReport from "@/modules/reports/SubscribeReport";

export default {
  name: "ModalsComponent",
  components: {SubscribeReport, ScheduleBlastComponent, NewBroadcastMessageComponent, NewGroup, VueTailwindModal},
  data() {
    return {
      showModal: false,
      modalData: Object
    }
  },
  mounted() {
    this.$root.$on("show_modal", (modalData) => {
      this.modalData = modalData;
      this.showModal = true;
    });
    this.$root.$on("hide_modal", () => {
      this.showModal = false;
    });
  },
}
</script>

<style scoped>
</style>